module.exports = __webpack_public_path__ + "static/media/heart.7678d0d3.svg";